import { Candidate } from '../data/mockCandidates';

export type SortField = 
  | 'name'
  | 'email'
  | 'referencesCompleted'
  | 'hardSkillsScore'
  | 'softSkillsScore'
  | 'status'
  | 'appliedDate';

export type SortDirection = 'asc' | 'desc';

export const sortCandidates = (
  candidates: Candidate[],
  field: SortField,
  direction: SortDirection
): Candidate[] => {
  return [...candidates].sort((a, b) => {
    const multiplier = direction === 'asc' ? 1 : -1;
    
    switch (field) {
      case 'name':
        return a.name.localeCompare(b.name) * multiplier;
      case 'email':
        return a.email.localeCompare(b.email) * multiplier;
      case 'referencesCompleted':
        const aRatio = a.referencesCompleted / a.referencesRequired;
        const bRatio = b.referencesCompleted / b.referencesRequired;
        return (aRatio - bRatio) * multiplier;
      case 'hardSkillsScore':
      case 'softSkillsScore':
        return (a[field] - b[field]) * multiplier;
      case 'status':
        const statusOrder = { completed: 0, in_progress: 1, pending: 2 };
        return (statusOrder[a.status] - statusOrder[b.status]) * multiplier;
      case 'appliedDate':
        return (new Date(a.appliedDate).getTime() - new Date(b.appliedDate).getTime()) * multiplier;
      default:
        return 0;
    }
  });
};